export default "__VITE_ASSET__B1t43DNa__"